import { ref, onMounted } from '@vue/composition-api'

export function useShowTimeout(time) {
  const show = ref(false)

  onMounted(() => setTimeout(() => show.value = true, time))

  return show
}